const MostReadSchema = () => ({
  title: 'AgSUS Mais Vistas',
  fieldsets: [
    {
      id: 'default',
      title: 'Geral',
      fields: ['title', 'limit', 'parentPath', 'portalTypes'],
    },
  ],
  properties: {
    title: {
      title: 'Título da lista',
      default: 'Notícias mais vistas',
    },
    limit: {
      title: 'Número de itens',
      type: 'integer',
      default: 5,
    },
    parentPath: {
      title: 'Pasta de origem',
      description: 'Path absoluto, ex: /noticias. Vazio = site inteiro.',
      default: '/noticias',
    },
    portalTypes: {
      title: 'Tipos de conteúdo',
      choices: [
        ['News Item', 'Notícia'],
      ],
      isMulti: true,
      default: ['News Item'],
    },
  },
  required: [],
});

export default MostReadSchema;
